export const framerAnimation = {
    left2right: {
        initial: {
            left: "-1000px"
        },
        animate: {
            left: "0"
        },
        exit: {
            left: "0"
        },
        transition: {
            duration: 1
        }
    },
    right2left: {
        initial: {
            left: "100vw"
        },
        animate: {
            left: "0"
        },
        exit: {
            left: "0"
        },
        transition: {
            duration: 1
        }
    },
    top2bottom: {
        initial: {
            top: "-1000px"
        },
        animate: {
            top: "auto"
        },
        exit: {
            top: "auto"
        },
        transition: {
            duration: 1
        }
    },
    bottom2top: {
        initial: {
            top: "1000px"
        },
        animate: {
            top: "auto"
        },
        exit: {
            top: "auto"
        },
        transition: {
            duration: 1
        }
    },
}